var render = function render(){var _vm=this,_c=_vm._self._c;return _c('El',{attrs:{"align":"center","pt":40}},[_c('El',{attrs:{"tag":"h3","mb":30}},[_vm._v(_vm._s(_vm.$copy.title))]),_c('El',{attrs:{"mb":25}},[_c('img',{attrs:{"src":require("@/assets/MyPCP-Enrollment-Confirmation.svg"),"alt":"LumerisEngage feature"}})]),_c('Message',{attrs:{"px":20}},[_vm._v(_vm._s(_vm.$copy.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }